






























































import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import { State } from 'vuex-class';

import RgMosesFaq from '../faq.vue';
import RgMosesBulletin from '../bulletin.vue';
import InfoTip from '@/views/components/info-tip.vue';
import ThirdRobot from './thirdRobot.vue';
import MosesRobot from './mosesRobot.vue';
import AbstractRobot from './AbstractRobot';
import { fetchRgAdmins } from '@/utils/business';
import type { Awaited } from '@/utils/type-utils';

@Component({ name: 'rg-moses', components: { RgMosesFaq, RgMosesBulletin, InfoTip, ThirdRobot, MosesRobot } })
export default class RgMoses extends Vue {
    rgId: number | null = null;
    activeTab = '';

    /** 是否开启机器人对话. */
    isRobotSettingEnabled = false;
    /** 当前选择的机器人类型. */
    robotType: 'third' | 'moses' = 'third';
    @Ref('thirdRobotRef') readonly thirdRobotRef!: AbstractRobot;
    @Ref('mosesRobotRef') readonly mosesRobotRef!: AbstractRobot;

    @State(state => state.cti.userInfo.username)
    private readonly userName: string;
    private rgAdmins: Awaited<ReturnType<typeof fetchRgAdmins>> = [];
    private readonly TAB_LIST = ['setting', 'bulletin', 'faq'];

    async mounted() {
        const { rgId, tab } = this.$route.query;
        this.rgId = parseInt(rgId as string, 10);
        if (this.TAB_LIST.indexOf(tab as string) > -1) {
            this.activeTab = tab as string;
        } else {
            this.activeTab = 'setting';
            const originalQuery = this.$route.query;
            this.$router.replace({ query: { ...originalQuery, tab: 'setting' } });
        }

        await this._initRgAdmins();

        // nextTick 保证子组件已经挂载，可以获取到子组件 ref
        this.$nextTick(() => {
            this._initRobotSetting();
        });
    }

    async handleRobotSettingEnabledChange(enabled: boolean) {
        if (enabled) {
            if (this.robotType === 'third') await this.thirdRobotRef.onShow();
            if (this.robotType === 'moses') await this.mosesRobotRef.onShow();
        } else {
            if (this.robotType === 'third') await this.thirdRobotRef.onHide();
            if (this.robotType === 'moses') await this.mosesRobotRef.onHide();
        }
    }

    async handleRobotTypeChange(robotType: 'third' | 'moses') {
        if (robotType === 'third') {
            await this.thirdRobotRef.onShow();
            await this.mosesRobotRef.onHide();
        } else {
            await this.thirdRobotRef.onHide();
            await this.mosesRobotRef.onShow();
        }
    }

    private async _initRgAdmins() {
        this.rgAdmins = await fetchRgAdmins(this.rgId);
    }

    private async _initRobotSetting() {
        const thirdRobotActive = await this.thirdRobotRef.getActiveState();
        const mosesRobotActive = await this.mosesRobotRef.getActiveState();
        this.isRobotSettingEnabled = !!(thirdRobotActive || mosesRobotActive);
        if (thirdRobotActive) this.robotType = 'third';
        if (mosesRobotActive) this.robotType = 'moses';
    }

    @Watch('activeTab')
    private _mutateTabQuery(newVal: string, oldVal: string) {
        if (newVal === oldVal) {
            return;
        }
        this.$router
            .push({
                query: {
                    ...this.$route.query,
                    tab: newVal
                }
            })
            .catch(e => {
                console.warn(e);
            });
    }

    get isThirdRobotVisible() {
        return this.isRobotSettingEnabled && this.robotType === 'third';
    }

    get isMosesRobotVisible() {
        return this.isRobotSettingEnabled && this.robotType === 'moses';
    }

    get hasRobotPermission() {
        // 当且仅当当前用户为管理员时，才有权限查看机器人设置.
        const userInfo = this.rgAdmins.find(item => item.identify === this.userName);
        if (!userInfo) return false;
        return userInfo.role === 'RGADMIN';
    }
}
